// Copyright (c) 2016 Deere & Company

import './product-list.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import ListViewShowMore from '../../../shared/components/list-view-show-more';
import ProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import SearchResult from './search-result';

const ProductList = props => {

    const list = props.products.length ?
        (<ListViewShowMore
            initialShowItems={50}
            perMoreMultiplier={1.25}
            showAllOption={true}
            showPerMore={50}
            totalItems={props.products.length}
         >
            {props.products.map((product, index) =>
                <SearchResult
                    key={index}
                    onClaimsModalOpen={props.onClaimsModalOpen}
                    onOpenStatusChangeModal={props.onOpenStatusChangeModal}
                    product={product}
                />
        )}
        </ListViewShowMore>) :
        <span className='empty'><FormattedMessage id='NO_RESULTS_FOUND'/></span>;

    return (
        <div className='product-list'>
            <div className='list-header'>
                {props.children}
            </div>
            {list}
        </div>
    );

};

ProductList.displayName = 'ProductList';
ProductList.propTypes = {
    children: PropTypes.node,
    onClaimsModalOpen: PropTypes.func.isRequired,
    onOpenStatusChangeModal: PropTypes.func.isRequired,
    products: PropTypes.arrayOf(PropTypes.instanceOf(ProductSearchResult)).isRequired
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/product/search/components/product-list.js